import React from 'react';
import { colors } from '../../lib/colors';
import { MediumText, RegularText, DemiLightText } from '../../lib/Text';
import { AdminAlert } from '../../types/adminAlert';
import { formatRelativeTime, getAlertAccentColor, getAlertTypeLabel } from './utils';
import SvgIcon from '../SvgIcon';

interface AlertCardProps {
    alert: AdminAlert;
    onClick: (alert: AdminAlert) => void;
    isLocked?: boolean;
}

const AlertCard: React.FC<AlertCardProps> = ({ alert, onClick, isLocked = false }) => {
    const accent = getAlertAccentColor(alert.type);
    const typeLabel = getAlertTypeLabel(alert.type);
    const title = isLocked ? '센터 리포트 잠금됨' : alert.title;
    const body = isLocked ? '2차 비밀번호 인증 후 리뷰 알림 내용을 확인할 수 있어요' : alert.body;

    return (
        <button
            type="button"
            onClick={() => onClick(alert)}
            className="w-full text-left px-[16px] py-[14px] transition-colors duration-150 hover:bg-[#F8FAFC] cursor-pointer relative"
            style={{
                backgroundColor: alert.isRead ? 'transparent' : '#F8FBFF',
            }}
        >
            {!alert.isRead && (
                <span
                    aria-hidden
                    className="absolute left-[6px] top-1/2 -translate-y-1/2 w-[6px] h-[6px] rounded-full"
                    style={{ backgroundColor: accent }}
                />
            )}
            <div className="flex items-center gap-[6px] mb-[4px]">
                <span
                    className="inline-flex items-center px-[6px] py-[1px] rounded-[6px]"
                    style={{
                        backgroundColor: `${accent}14`,
                        color: accent,
                        fontSize: 11,
                        fontWeight: 600,
                        lineHeight: '16px',
                    }}
                >
                    {typeLabel}
                </span>
                <DemiLightText fontSize={11} lineHeight={16} color={colors.LAVEL_4}>
                    {formatRelativeTime(alert.createdAt)}
                </DemiLightText>
            </div>
            <MediumText
                fontSize={13}
                lineHeight={18}
                color={alert.isRead ? colors.LAVEL_3 : colors.Text_1}
                className="flex items-center gap-[5px] mb-[2px] overflow-hidden whitespace-nowrap text-ellipsis"
            >
                {isLocked && <SvgIcon name="SvgLock" size={12} fill={colors.LAVEL_3} stroke={colors.LAVEL_3} />}
                <span className="overflow-hidden whitespace-nowrap text-ellipsis">{title}</span>
            </MediumText>
            <RegularText
                fontSize={12}
                lineHeight={17}
                color={alert.isRead ? colors.LAVEL_4 : colors.LAVEL_3}
                className="block overflow-hidden whitespace-nowrap text-ellipsis"
            >
                {body}
            </RegularText>
        </button>
    );
};

export default AlertCard;
